import { render, staticRenderFns } from "./ActiveAds.vue?vue&type=template&id=079bbe90&lang=html&"
import script from "./ActiveAds.vue?vue&type=script&lang=js&"
export * from "./ActiveAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports